import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { deletePollFb, fetchPollStateFb } from '../db';
import { IAppState } from '../db/reducers';

const SForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SFormBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start
`;

const SBtnGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: space-evenly;
`;

interface IRemovePollDrawer {
  pollId: string
  deletePoll(pollId: string): void;
  getPollsList(): void;
  setDrawerVisible: (isVis: boolean) => unknown;
}

const RemovePollDrawer: React.SFC<IRemovePollDrawer> = (props) => {
  const history = useHistory();

  const { deletePoll, getPollsList, setDrawerVisible } = props
  const { pollId } = props;

  const removePoll = () => {
    deletePoll(pollId);
    getPollsList();
    history.push(`/admin`);
    setDrawerVisible(false);
  };

  return (
    <SForm className='poll-remover'>
      <h2 style={{ margin: '0 0 2vh 0'}}>Delete Poll?</h2>
      <SFormBody>
        <p style={{ margin: '0 1vw 1vh 1vw', fontWeight: 'lighter'}}>
          Are you sure you want to delete poll&nbsp;<i>{pollId} </i> &nbsp;?
        </p>
        <p style={{ margin: '0 1vw 2vh 1vw', fontWeight: 'lighter'}}>This cannot be undone.</p>
      </SFormBody>
      <SBtnGroup>
        <button type='button' onClick={() => setDrawerVisible(false)}>Cancel</button>
        <button type='button' onClick={() => removePoll()}>Confirm</button>
      </SBtnGroup>
    </SForm>
  );
};

const mapStateToProps = (state: IAppState) => state;

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    deletePoll: async (currentPollId: string) => {
      await deletePollFb(currentPollId)(dispatch)
    },
    getPollsList: async () => {
      await fetchPollStateFb(dispatch);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RemovePollDrawer);
